import type { ReactNode } from "react";
import { tw } from "../../styling";

type ICardHeader = {
	children: ReactNode;
	classNames?: string;
};

export const CardHeader = ({ children, classNames = "" }: ICardHeader) => {
	return (
		<div
			className={tw(
				"tablet:px-6 tablet:pt-6 flex flex-row items-start justify-between gap-4 rounded-t-lg px-4 pt-4 pb-2",
				"bg-background-transparent",
				classNames,
			)}
		>
			{children}
		</div>
	);
};
